import { useTranslator } from '@Localization';
import { ReactElement } from 'react';
import { S_ListSelect } from '../../../../../../../../design/inputs/select/S_ListSelect';
import { WarningIconBadge } from '../../../../../../../components/badges/iconBadges/WarningIconBadge';
import { IDatasetFilterOption } from '../../../imageFilters.model';
import { FilterContent } from '../FilterContent';
import { ImageFiltersFormProps } from '../ImageFiltersForm';

interface InDatasetsLabelProps {
  item: IDatasetFilterOption;
}

const InDatasetsLabel = ({ item }: InDatasetsLabelProps): ReactElement => {
  const { t } = useTranslator();
  const showWarning = item.datasetStatus !== 'Published' && item.datasetStatus !== 'PublishedUploading';

  return (
    <span className='text'>
      {showWarning && <WarningIconBadge title={t('unpublished')} />} {item.name}
    </span>
  );
};

export const InDatasetsBody = ({ availableFilters, imageFilters, onSetInDatasets }: ImageFiltersFormProps): ReactElement => {
  const options = availableFilters.datasets.map((x) => ({ value: x.id, label: <InDatasetsLabel item={x} />, searchableLabel: x.name }));

  return (
    <FilterContent>
      <S_ListSelect
        options={options}
        selected={imageFilters.datasets}
        onChange={onSetInDatasets}
      />
    </FilterContent>
  );
};
